/*
 *@Description: 智能填写
 *@ComponentAuthor: Xu Jian
*/
<template>
  <div>
    <el-dialog lock-scroll
               :modal-append-to-body="false"
               :append-to-body="true"
               :title="$lang('智能地址填写')"
               custom-class="jms-dialog"
               :close-on-click-modal="false"
               :visible.sync="visible"
                @close="close"
               width="900px">
      <div class="overflow">
        <div class="tip">{{$lang('你也可以贴整段地址，自动识别姓名、电话和地址。')}}</div>
        <el-input v-model="data"
                  :placeholder="$lang('例如：Ego小哥，+6281912345，湖北省黄石市某某大厦666号')"
                  type="textarea"
                  :rows="9"
                  :maxlength="120"
                  resize="none"></el-input>
      </div>
      <div class="dialog-footer">
        <el-button @click="close">{{$lang('关 闭')}}</el-button>
        <el-button type="primary" @click="test">{{$lang('识 别')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import { mapGetters } from 'vuex'

export default {
  name: 'SmartSpot',
  props: {
    value: {},
    spotType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: '',
      visible: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created() {
  },
  mounted() {
  },
  methods: {
    test() {

    },
    async getTestResult() {
      const { code, data, msg } = {}
      if (code === RESPONSE_SUCCESS) {
        this.testData = data
      } else {
        this.testData.msg = msg
        this.$message.error(this.$lang(msg))
      }
    },
    close() {
      this.visible = false
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
    },

  },
}
</script>

<style scoped lang="scss" scoped>
.tip{
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

</style>
